import { useState } from "react";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import { PropagateLoader } from "react-spinners";
import Button from "../../../atoms/Button";
import SubHeading from "../../../atoms/SubHeading";
import InputField from "../../../atoms/InputField";
import InmuebleDocsList from "./InmuebleDocsList";
import { UPDATE_HIPOTECA } from "../../../../api/apiFiles";

const HipotecaTable = ({ data, refetch, loading }) => {
    const [loadingUpdate, setLoadingUpdate] = useState();
    const [clickedOnce, setClickedOnce] = useState(false);

    const validationSchema = Yup.object({
        banco: Yup.string().required("El banco es obligatorio"),
        titular_hipoteca: Yup.string().required("El nombre del titular de la hipoteca es requerido"),
    });

    const initialValues = { banco : data?.banco || "", titular_hipoteca : data?.titular_hipoteca || "" };

    const handleSubmit = (values, { setSubmitting }) => {
        if (clickedOnce) return;
        setClickedOnce(true);
        setLoadingUpdate(true);

        toast.promise(
            UPDATE_HIPOTECA(data?.id, {} ,values),
            { pending: 'Editando hipoteca...', success: 'Hipoteca editada correctamente.', error: 'No se pudo editar la hipoteca.' }
        ).then(() => {
            refetch();
        }).catch((error) => {
            console.error(error);
        }).finally(()=> {
            setLoadingUpdate(false);
            setSubmitting(false);
            setTimeout(() => setClickedOnce(false), 9999);
        });
    };

    return (
        <>
            <SubHeading text="Editar información (Para editar documentos haga click en cada uno)" color="black" />
            <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
                {({ isSubmitting }) => (
                    <Form className="flex flex-col items-center gap-5">
                        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 ">
                            <InputField name="banco" label="Banco" placeholder="Banco" />
                            <InputField name="titular_hipoteca" label="Titular de la hipoteca" placeholder="Titular de la hipoteca" />
                        </div>
                        <Button
                            type="submit"
                            bgColor="blue"
                            disabled={isSubmitting || loading || loadingUpdate || clickedOnce}
                            text={(isSubmitting || loading || loadingUpdate ) ? <PropagateLoader color="red" /> : "Actualizar" }
                        />
                    </Form>
                )}
            </Formik>
            <InmuebleDocsList data={data} refetch={refetch} />
        </>
    );
};

export default HipotecaTable;
